import { render, staticRenderFns } from "./TheoryPracticeWorkshopLessonTheories.vue?vue&type=template&id=55b9326e&scoped=true&"
import script from "./TheoryPracticeWorkshopLessonTheories.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopLessonTheories.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopLessonTheories.vue?vue&type=style&index=0&id=55b9326e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9326e",
  null
  
)

export default component.exports